import { dateFormatThree, currencyFormat } from '../../../Functions';
export function LoadingConfirm(XLSX, data) {
    // console.log('data', data)
    var wb = XLSX.utils.book_new();

    data.forEach(el => {
        var ws = XLSX.utils.json_to_sheet([
            { A: 'OCEAN TRANSPORT GROUP OF COMPANIES INC.' }
        ], { header: [], skipHeader: true });

        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: "LOADING CONFIRMATION" }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: "Voyage Sequence: " + el.voyage }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: `Vessel: ${el.vessel}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Shipper: ${el.shipper}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Email: ${el.shipperEmail}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Origin: ${el.origin}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `ETD: ${el.etd}` }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{
            A: "No.",
            B: "BOOKING DATE",
            C: "CY-IN",
            D: "VAN NUMBER",
            E: "SEAL #",
            F: "WAYBILL",
            G: "CARGO DESCRIPTION",
            H: "SERVICE MODE",
            I: "PAY MODE",
            J: "CONSIGNEE",
            K: "EMAIL",
            L: "DESTINATION",
            M: "ETA",
            N: "TRANSACTION REF",
            O: "CAGO TYPE",
            P: "VALUE",
            Q: "REMARKS"
        }], { header: [], skipHeader: true, origin: -1 });

        el.myDetails.forEach((detail, i) => {
            var thisDate = new Date(detail.cyIn);
            let CYdate = (thisDate.getMonth() + 1) + "/" + thisDate.getDate() + "/" + thisDate.getFullYear();
            let BookingDate = dateFormatThree(detail.bookingDate);
            XLSX.utils.sheet_add_json(ws, [{
                A: i + 1,
                B: BookingDate,
                C: CYdate,
                D: detail.cargo,
                E: detail.sealNum,
                F: detail.wayBillRef,
                G: detail.goods,
                H: detail.modeOfDelivery,
                I: detail.modeOfPayment,
                J: detail.consignee,
                K: detail.consigneeEmail,
                L: detail.destination,
                M: detail.eta,
                N: detail.transactionRef,
                O: detail.cargoType,
                P: currencyFormat(detail.declaredValue),
                Q: detail.remarks
            }], { header: [], skipHeader: true, origin: -1 });
        })

        var wscols = [
            { wch: 4 },  // Count
            { wch: 13 }, // booking date
            { wch: 10 }, // cy-in
            { wch: 13 }, // van num
            { wch: 15 }, // seal
            { wch: 15 }, // waybill
            { wch: 25 }, // goods
            { wch: 12 }, // service mode
            { wch: 12 }, // pay mode
            { wch: 25 }, // consignee
            { wch: 25 }, // email
            { wch: 12 }, // destination
            { wch: 13 }, // eta
            { wch: 15 }, // transaction ref
            { wch: 11 }, // cargo type
            { wch: 11 }, // value
            { wch: 25 },  // remarks
        ];

        ws['!cols'] = wscols;

        XLSX.utils.book_append_sheet(wb, ws, el.transactionRef);
    });

    XLSX.writeFile(wb, "Loading_Confirmation.xlsx");
}